<div class="roulettes-wrapper column">
  <ng-container *ngIf="roulettes$ | async as roulettes">

    <div class="summary-bar" *ngIf="roulettes.length > 0">
      <div class="summary-item">
        <span class="summary-label">{{ 'ROULETTE.TOTAL_ROULETTES' | translate }}:</span>
        <span class="summary-value">{{ roulettes.length }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">{{ 'ROULETTE.ACTIVE_ROULETTES' | translate }}:</span>
        <span class="summary-value active">{{ getActiveCount(roulettes) }}</span>
      </div>
    </div>

    <ng-container *ngFor="let roulette of roulettes">
    <div class="roulette-card" [ngClass]="getStatusClass(roulette.Status)">

      <div class="card-header">
        <div class="header-right">
          <span class="roulette-name">{{ roulette.Name }}</span>
          <span class="type-badge" [class.frontal]="roulette.PackageType === 3">
            {{ getPackageTypeLabel(roulette) }}
          </span>
        </div>
        <span class="status-badge" [ngClass]="getStatusClass(roulette.Status)">
          {{ roulette.Status | enumTranslate:WebRouletteStatus }}
        </span>
      </div>

      <div class="card-body">
        <div class="info-grid">

          <div class="info-item">
            <i class="pi pi-sync info-icon"></i>
            <span class="label">{{ 'ROULETTE.ROUNDS' | translate }}:</span>
            <span class="value">
              {{ roulette.ActualSpinsCount }}
              <span *ngIf="roulette.SpinsCountInPackage && roulette.SpinsCountInPackage > 0">
                / {{ roulette.SpinsCountInPackage }}
              </span>
            </span>
          </div>

          <div class="info-item">
            <i class="pi pi-users info-icon"></i>
            <span class="label">{{ 'ROULETTE.LIDS' | translate }}:</span>
            <span class="value">{{ roulette.ActualRouletteLids }}</span>
          </div>

          <div class="info-item" *ngIf="roulette.PackageName">
            <i class="pi pi-box info-icon"></i>
            <span class="label">{{ 'BUSINESS_MANAGEMENT.PACKAGE_NAME' | translate }}:</span>
            <span class="value">{{ roulette.PackageName }}</span>
          </div>

          <div class="info-item" *ngIf="roulette.PackagePaymentType">
            <i class="pi pi-credit-card info-icon"></i>
            <span class="label">{{ 'BUSINESS_MANAGEMENT.PAYMENT_METHOD' | translate }}:</span>
            <span class="value">{{ getPaymentTypeLabel(roulette.PackagePaymentType) }}</span>
          </div>

          <div class="info-item" *ngIf="roulette.PackagePriceShekels || roulette.PackagePriceDollars">
            <i class="pi pi-tag info-icon"></i>
            <span class="label">{{ 'BUSINESS_MANAGEMENT.PACKAGE_PRICE' | translate }}:</span>
            <span class="value" *ngIf="roulette.PackagePriceShekels">{{ roulette.PackagePriceShekels | currency:'ILS':'symbol':'1.0-0' }}</span>
            <span class="value" *ngIf="!roulette.PackagePriceShekels && roulette.PackagePriceDollars">{{ roulette.PackagePriceDollars | currency:'USD':'symbol':'1.0-0' }}</span>
          </div>

          <div class="info-item" *ngIf="roulette.CreatedDate">
            <i class="pi pi-calendar info-icon"></i>
            <span class="label">{{ 'ROULETTE.CREATE_DATE' | translate }}</span>
            <span class="value">{{ formatDate(roulette.CreatedDate) }}</span>
          </div>

          <div class="info-item" *ngIf="roulette.StartDate">
            <i class="pi pi-calendar-check info-icon"></i>
            <span class="label">{{ 'BUSINESS_MANAGEMENT.SUBSCRIPTION_START_DATE' | translate }}</span>
            <span class="value">{{ formatDate(roulette.StartDate) }}</span>
          </div>

          <div class="info-item" *ngIf="roulette.EndDate">
            <i class="pi pi-calendar-times info-icon"></i>
            <span class="label">{{ 'ROULETTE.EXPIRY' | translate }}:</span>
            <span class="value">{{ formatDate(roulette.EndDate) }}</span>
          </div>

        </div>

        <div class="link-section" *ngIf="roulette.RouletteLink || canStopAutoRenewal(roulette) || canCancelSubscription(roulette) || roulette.IsSubscriptionCanceled">
          <ng-container *ngIf="roulette.RouletteLink">
            <button class="copy-btn" pTooltip="{{ 'ROULETTE.COPY' | translate }}" [copyToClipboard]="roulette.RouletteLink">
              <i class="pi pi-copy"></i>
            </button>
            <a class="roulette-link" [href]="roulette.RouletteLink" target="_blank" rel="noopener noreferrer">
              <i class="pi pi-external-link"></i>
              {{ 'ROULETTE.LINK_ROULETTE' | translate }}
            </a>
            <span class="link-separator" *ngIf="canStopAutoRenewal(roulette) || canCancelSubscription(roulette) || roulette.IsSubscriptionCanceled">|</span>
          </ng-container>
          <button
            *ngIf="canStopAutoRenewal(roulette)"
            class="cancel-link-btn"
            [disabled]="stoppingRenewalRouletteId === roulette.Id"
            (click)="stopAutoRenewal(roulette)">
            <i class="pi" [ngClass]="stoppingRenewalRouletteId === roulette.Id ? 'pi-spin pi-spinner' : 'pi-stop-circle'"></i>
            <span>{{ 'ROULETTE.STOP_AUTO_RENEWAL' | translate }}</span>
          </button>
          <span class="link-separator" *ngIf="canStopAutoRenewal(roulette) && (canCancelSubscription(roulette) || roulette.IsSubscriptionCanceled)">|</span>
          <button
            *ngIf="canCancelSubscription(roulette) || roulette.IsSubscriptionCanceled"
            class="cancel-link-btn"
            [disabled]="roulette.IsSubscriptionCanceled || cancellingRouletteId === roulette.Id"
            (click)="openCancelConfirm(roulette)">
            <i class="pi" [ngClass]="cancellingRouletteId === roulette.Id ? 'pi-spin pi-spinner' : 'pi-ban'"></i>
            <span *ngIf="!roulette.IsSubscriptionCanceled">{{ 'ROULETTE.CANCEL_SUBSCRIPTION' | translate }}</span>
            <span *ngIf="roulette.IsSubscriptionCanceled">{{ 'ROULETTE.SUBSCRIPTION_ALREADY_CANCELLED' | translate }}</span>
          </button>
        </div>

      </div>
    </div>
    </ng-container>

  </ng-container>

  <div class="empty-state" *ngIf="(roulettes$ | async)?.length === 0">
    <i class="pi pi-inbox" style="font-size: 2rem; color: #aaa;"></i>
    <p>{{ 'ROULETTE.NO_ROULETTES' | translate }}</p>
  </div>
</div>

<!-- Cancel subscription confirmation dialog -->
<p-dialog
  [(visible)]="showCancelConfirm"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '440px'}"
  [header]="'ROULETTE.CANCEL_SUBSCRIPTION_TITLE' | translate">
  <div class="cancel-dialog-body">
    <p *ngIf="rouletteToCancel" class="roulette-name-row">
      <i class="pi pi-spin-circle"></i>
      <strong>{{ rouletteToCancel.Name }}</strong>
    </p>
    <p class="cancel-dialog-msg">{{ 'ROULETTE.CANCEL_SUBSCRIPTION_MSG' | translate }}</p>
  </div>
  <ng-template pTemplate="footer">
    <div class="cancel-dialog-footer">
      <button pButton type="button" label="{{ 'GENERAL.CANCEL' | translate }}" class="p-button-outlined p-button-secondary" (click)="cancelCancelDialog()"></button>
      <button pButton type="button" label="{{ 'GENERAL.OK' | translate }}" class="p-button-danger" (click)="confirmCancel()"></button>
    </div>
  </ng-template>
</p-dialog>
